import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  isLoading = true;

  hideLoader() {
    this.isLoading = false;
  }
}
